<script setup lang="ts">
  import PosUiIcon from '@/components/pos-v2/ui/PosUiIcon.vue';

  export interface IWizardPaperChoice {
    format: 'escpos' | 'zpl';
    paperWidthMm: 58 | 80;
  }

  const emit = defineEmits<{
    (e: 'select', choice: IWizardPaperChoice): void;
  }>();

  const options: {
    key: string;
    icon: string;
    titleKey: string;
    descKey: string;
    choice: IWizardPaperChoice;
  }[] = [
    {
      key: '80',
      icon: 'receipt',
      titleKey: 'printingV2.paper80Title',
      descKey: 'printingV2.paper80Desc',
      choice: { format: 'escpos', paperWidthMm: 80 },
    },
    {
      key: '58',
      icon: 'receipt-text-outline',
      titleKey: 'printingV2.paper58Title',
      descKey: 'printingV2.paper58Desc',
      choice: { format: 'escpos', paperWidthMm: 58 },
    },
    {
      key: 'zpl',
      icon: 'tag-outline',
      titleKey: 'printingV2.paperZplTitle',
      descKey: 'printingV2.paperZplDesc',
      choice: { format: 'zpl', paperWidthMm: 80 },
    },
  ];
</script>

<template>
  <div class="wizard-step-paper">
    <button
      v-for="option in options"
      :key="option.key"
      type="button"
      class="paper-card"
      @click="emit('select', option.choice)"
    >
      <div class="paper-card-icon">
        <PosUiIcon :name="option.icon" :size="26" />
      </div>
      <div class="paper-card-title">{{ $t(option.titleKey) }}</div>
      <div class="paper-card-desc">{{ $t(option.descKey) }}</div>
    </button>
  </div>
</template>

<style scoped lang="scss">
  .wizard-step-paper {
    @apply tw-grid tw-grid-cols-1 tw-gap-3 sm:tw-grid-cols-3;

    .paper-card {
      @apply tw-flex tw-flex-col tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-neutral-200 tw-bg-white tw-px-4 tw-py-6 tw-text-center tw-transition-colors hover:tw-border-orange-300 hover:tw-bg-orange-50/40;

      .paper-card-icon {
        @apply tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-xl tw-bg-neutral-100 tw-text-neutral-500;
      }

      .paper-card-title {
        @apply tw-text-sm tw-font-semibold tw-text-neutral-900;
      }

      .paper-card-desc {
        @apply tw-text-xs tw-text-neutral-500;
      }
    }
  }
</style>
